import { render, staticRenderFns } from "./multi-source.vue?vue&type=template&id=668b35b8&scoped=true"
import script from "./multi-source.vue?vue&type=script&lang=js"
export * from "./multi-source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b35b8",
  null
  
)

export default component.exports